module.exports = __webpack_public_path__ + "static/img/9en.de34238.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/yijia/9en.png
// module id = uKIJ
// module chunks = 0